import styled from 'styled-components';

interface StyledChatListItemProps {
  $fromUser: boolean;
}

const StyledChatListItem = styled.div<StyledChatListItemProps>`
  display: inline-flex;
  gap: 18px;
  align-self: ${(props) => props.$fromUser ? 'end' : 'start'};
  align-items: end;
  margin-bottom: 20px;
  line-height: 1.4;
  max-width: 650px;
  word-break: break-word;

  .avatar-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }

  p {
    margin-top: 0;
    margin-bottom: 10px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul {
    padding-left: 16px;
    margin-top: 0;
    margin-bottom: 0;
  }

  li {
    margin-bottom: 10px;
  }
`;

export default StyledChatListItem;